/** localStorage: bienvenida beta mostrada una vez por navegador. */
export const BETA_WELCOME_STORAGE_KEY = 'dreamvinyl_beta_welcome_v2';

export function isBetaWelcomePending() {
  try {
    return typeof localStorage !== 'undefined' && !localStorage.getItem(BETA_WELCOME_STORAGE_KEY);
  } catch {
    return false;
  }
}

export function markBetaWelcomeSeen() {
  try {
    localStorage.setItem(BETA_WELCOME_STORAGE_KEY, '1');
  } catch {
    /* ignore */
  }
}
